const pendingFontLoads = new Map();

const fontDescriptor = (fontFamily, fontWeight) => {
  const safeFamily = String(fontFamily).replace(/["\\]/g, "\\$&");
  const numericWeight = Number(fontWeight);
  const weight = Number.isFinite(numericWeight) ? numericWeight : 400;
  return `${weight} 16px "${safeFamily}"`;
};

export const preloadFontFamily = (fontFamily, fontWeight = 400) => {
  if (!fontFamily || typeof document === "undefined") {
    return Promise.resolve([]);
  }

  const fontSet = document.fonts;
  if (!fontSet?.load) return Promise.resolve([]);

  const descriptor = fontDescriptor(fontFamily, fontWeight);
  if (fontSet.check?.(descriptor)) return Promise.resolve([]);
  if (pendingFontLoads.has(descriptor)) return pendingFontLoads.get(descriptor);

  const request = fontSet
    .load(descriptor)
    .catch(() => [])
    .finally(() => pendingFontLoads.delete(descriptor));

  pendingFontLoads.set(descriptor, request);
  return request;
};

export const resetFontLoadCacheForTests = () => pendingFontLoads.clear();
